import SettingConfig from '../../config/setting';

class Condition<T, TCond extends string = never> {
  public operand: T;
  public conditions = new Set<string>();

  constructor(operand: T) {
    this.operand = operand;
  }

  addCond<CondOut extends string>(condFn: (operand: T) => CondOut | undefined): Condition<T, TCond | CondOut> {
    const result = condFn(this.operand);
    if (result) {
      this.conditions.add(result);
    }
    return this;
  }

  if(conditionName: TCond): boolean;
  if<U>(conditionName: TCond, fn: U): U | undefined;
  if<U>(conditionName: TCond, fn?: U): boolean | U | undefined {
    if (this.conditions.has(conditionName)) {
      if (!fn) return true;
      return fn;
    }
    if (!fn) {
      return false;
    }
    return undefined;
  }
}

export const aspCond = new Condition(SettingConfig)
  .addCond((SettingConfig) => {
    if (SettingConfig?.newASPPreset || SettingConfig?.iframeASPConfig) return 'asp';
  })
  .addCond((settingConfig) => {
    if (settingConfig?.iframeASPConfig) return 'iframe-asp';
  })
  .addCond((settingConfig) => {
    if (settingConfig?.newASPPreset) return 'new-asp';
  })
  .addCond((SettingConfig) => {
    if (SettingConfig?.iframeASPConfig?.aspInfo?.type === 'A' || SettingConfig?.newASPPreset?.aspInfo?.type === 'A')
      return 'asp-a';
  })
  .addCond((SettingConfig) => {
    if (SettingConfig?.iframeASPConfig?.aspInfo?.type === 'B' || SettingConfig?.newASPPreset?.aspInfo?.type === 'B')
      return 'asp-b';
  });
